import React from "react";
import { Link } from "react-router-dom";
import { Column, Grid, Row } from "carbon-components-react";
import { Icon } from "../simple/Icon";
import { Trans } from "react-i18next";
import { LanguageSwitcher } from "../LaguageSwitcher";
import i18n from "../../i18n";

export const Footer = () => {
  return (
    <footer className="lb-footer-block">
      <Grid>
        <Row>
          <Column lg={12}>
            <div className="lb-footer">
              <div className="lb-footer-block__top">
                <ul className="body-short-02">
                  <li>
                    <Link to="/faq">
                      <Trans i18nKey="Footer.NavBar.Faq" />
                    </Link>
                  </li>
                  <li>
                    <a
                      href={i18n.t("NavBar.InternetBank.link")}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Trans i18nKey="NavBar.InternetBank" />
                    </a>
                  </li>
                  <li>
                    <a
                      href={i18n.t("NavBar.PrivacyPolicy.link")}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Trans i18nKey="NavBar.PrivacyPolicy" />
                    </a>
                  </li>
                </ul>
                <div className="lb-card-icon">
                  <div className="contact-info">
                    <i className="icn">
                      <Icon name="Path_6004" viewBox="0 0 24 24" />
                    </i>
                    <span>
                      <a href={`tel:${i18n.t("Common.Phone")}`}>
                        <Trans i18nKey="Common.Phone" />
                      </a>
                    </span>
                  </div>
                  <div className="contact-info">
                    <i className="icn">
                      <Icon name="Path_6026" viewBox="0 0 24 24" />
                    </i>
                    <span>
                      <a href={`mailto:${i18n.t("Common.Email")}`}>
                        <Trans i18nKey="Common.Email" />
                      </a>
                    </span>
                  </div>
                  <span className="year text-01 mr-32">
                    © {new Date().getFullYear()}
                  </span>
                </div>
              </div>
              <div className="lb-footer-block__bottom">
                <div className="lb-footer-block__details">
                  <div className="flex-items-center pointer">
                    <i className="icn pr-8">
                      <Icon name="language" viewBox="0 0 20 20" />
                    </i>

                    <LanguageSwitcher className="body-short-02" />
                  </div>
                </div>
                <div className="lb-soc-block flex-items-center">
                  <span className="year text-01 body-short-02 mr-16">
                    © {new Date().getFullYear()}
                  </span>
                  <a
                    href={i18n.t("Common.Facebook.Url")}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="icn">
                      <Icon name="logo-facebook" viewBox="0 0 20 20" />
                    </i>
                  </a>
                  <a
                    href={i18n.t("Common.Linkedin.Url")}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="icn">
                      <Icon name="logo-linkedin" viewBox="0 0 20 20" />
                    </i>
                  </a>
                  <a
                    href={i18n.t("Common.Bee.Url", {
                      lang: i18n.language,
                    })}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="icn">
                      <Icon name="bee" viewBox="0 0 14 12" />
                    </i>
                  </a>
                </div>
              </div>
            </div>
          </Column>
        </Row>
      </Grid>
    </footer>
  );
};
